module.exports = __webpack_public_path__ + "static/media/icon_location_station.26f4c2af.png";